import {AbstractControl, ValidatorFn} from "@angular/forms";

export function requireIfNullValidator(control: AbstractControl,otherControl: AbstractControl): ValidatorFn {

  return (form: AbstractControl): {[key: string]: any} | null => {
    if((otherControl.value == '' || otherControl.value == null || otherControl.value == undefined )
      && (control.value == '' || control.value == null || control.value == undefined)){
      return { 'required': { value: false }};
    }
    return null;

  };
}
